import { createContext, useContext } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { useAuthContext } from './AuthContext';

const PermissionsContext = createContext(null);

export const PermissionsProvider = ({ children }) => {
  const auth = useAuthContext();
  
  // Guard: If auth isn't ready, permissions aren't ready
  const user = auth ? auth.user : null;
  const permissions = usePermissions(user);

  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissionsContext = () => useContext(PermissionsContext);